<div class="sidebar-shell" [class.sidebar-collapsed]="!isSideBarOpen">
  <nav
    class="navbar show navbar-vertical h-lg-screen navbar-expand-lg px-0 py-3 navbar-light bg-white border-bottom border-bottom-lg-0 border-end-lg clug-sidebar"
    [class.sidebar-collapsed]="!isSideBarOpen" id="sidebar">
    <div class="container-fluid">

      <!-- Toggler -->
      <button class="navbar-toggler ms-n2" (click)="toggleCollapse()">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Brand -->
      <a class="navbar-brand brand py-lg-2 me-0" routerLink="/dashboard">
        <img src="{{dataSharedService.agencyLogo}}" />
      </a>

      <!-- User menu (mobile) -->
      <div class="navbar-user d-lg-none">
        <div class="dropdown">
          <a role="button" id="mobile-setting-dropdown" data-bs-toggle="dropdown" aria-expanded="false">
            <div class="avatar-parent-child">
              <img alt="..." src="{{dataSharedService.profileImage}}" class="avatar avatar- rounded-circle">
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-end" id="mobile-setting-dropdown">
            <div class="dropdown-header">
              <span class="d-block text-sm text-muted mb-1 text-start">Signed in as</span>
              <span class="d-block text-heading font-semibold text-start">{{user.name}}</span>
            </div>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="/dashboard">
              <i class="bi bi-house me-3"></i>Home
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="/settings">
              <i class="bi bi-gear me-3"></i>Settings
            </a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" routerLink="/logout">
              <i class="bi bi-person me-3"></i>Logout
            </a>
          </div>
        </div>
      </div>


      <!-- Collapse -->
      <div class="collapse navbar-collapse {{visible ? 'show dinesh-chandel': 'dinesh-chandel'}}" id="sidebarCollapse">
        <div class="sidebar-nav">
          <ng-container *ngFor="let group of navGroups">
            <ng-container *ngIf="getMenusByGroup(group) as items">
              <ng-container *ngIf="items.length">
                <div class="group-label">{{group}}</div>
                <ng-container *ngFor="let permissionMenu of items">
                  <a class="nav-item" *ngIf="!permissionMenu.hasSubMenu" [routerLink]="permissionMenu.path"
                    routerLinkActive="active" [matTooltip]="isSideBarOpen ? null : permissionMenu.name"
                    [matTooltipPosition]="'right'" (click)="toggleCollapse()">
                    <span class="ico"><i [ngClass]="permissionMenu.icon"></i></span>
                    <span class="label">{{permissionMenu.name}}</span>
                    <span class="badge" *ngIf="permissionMenu.badge">{{permissionMenu.badge}}</span>
                  </a>

                  <div class="nav-item-with-sub" *ngIf="permissionMenu.hasSubMenu">
                    <a href="javascript:;" class="nav-item" (click)="showSubMenuDropdown(permissionMenu.hasSubMenu)"
                      [matTooltip]="isSideBarOpen ? null : permissionMenu.name" [matTooltipPosition]="'right'">
                      <span class="ico"><i [ngClass]="permissionMenu.icon"></i></span>
                      <span class="label">{{permissionMenu.name}}</span>
                    </a>
                    <div class="submenu" *ngIf="showReportSubmenu">
                      <a href="javascript:;" *ngFor="let childMenu of permissionMenu.subMenus.list" class="submenu-item"
                        [routerLink]="childMenu.path" routerLinkActive="active"
                        [matTooltip]="isSideBarOpen ? null : childMenu.name" [matTooltipPosition]="'right'"
                        (click)="toggleCollapse()">
                        <span *ngIf="isSideBarOpen">{{childMenu.name}}</span>
                      </a>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>

        <div class="sidebar-footer">
          <a class="nav-item" href="javascript:;" [matTooltip]="isSideBarOpen ? '' : 'Help & support'"
            [matTooltipPosition]="'right'" (click)="openHelpSupport()">
            <span class="ico"><i class="bi bi-question-circle"></i></span>
            <span class="label">Help &amp; support</span>
          </a>
        </div>
      </div>
    </div>
  </nav>

  <!-- Desktop collapse/expand toggle (sibling of nav, escapes its overflow) -->
  <div class="sidebar-toggle-row d-none d-lg-flex">
    <button type="button" class="sidebar-toggle-btn" (click)="dataSharedService.toggleSidebar()"
      [attr.aria-label]="isSideBarOpen ? 'Collapse sidebar' : 'Expand sidebar'"
      [matTooltip]="isSideBarOpen ? 'Collapse sidebar' : 'Expand sidebar'" matTooltipPosition="right">
      <i class="bi" [ngClass]="isSideBarOpen ? 'bi-chevron-double-left' : 'bi-chevron-double-right'"></i>
    </button>
  </div>
</div>
<!-- Sidebar End -->